"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IssuePlacementsApi = void 0;
var _constants = require("../constants");
var _endpointHelpers = require("../util/endpointHelpers");
var _urlExtractors = require("../util/urlExtractors");
const IssuePlacementsApi = exports.IssuePlacementsApi = (0, _endpointHelpers.createEndpointSdk)(_ref => {
  let {
    api
  } = _ref;
  return {
    unlink: issueId => api.request("issues/".concat(issueId, "/pins:unlink"), _constants.HttpMethod.Post),
    //TODO replace with placements:unlink once it is merged (https://git.autodesk.com/BIM360/acc-issues-service/pull/165)
    upsert: (issueId, placements) => api.request("issues/".concat(issueId, "/placements:upsert"), _constants.HttpMethod.Post, {
      placements: placements
    }),
    batchGet: issueIds => api.request("pins:batchGet", _constants.HttpMethod.Post, {
      issueIds: issueIds
    })
  };
}, {
  invalidateByQueryKeys: url => {
    const issueId = (0, _urlExtractors.extractIssueId)(url);
    return [["issues", issueId]];
  }
});
//# sourceMappingURL=IssuePlacementsApi.js.map